module.exports = __webpack_public_path__ + "img/Hoja_Dorada.a406b234.png";